var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Web--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Web Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web--server-world-internet-earth-www-globe-worldwide-web-network"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M5.04883 0.275541C2.32493 1.06453 0.285118 3.46373 0.0275269 6.375H3.22773c0.18833 -2.14874 0.81138 -4.22578 1.8211 -6.099459ZM3.22773 7.625H0.0275269C0.285118 10.5363 2.32493 12.9355 5.04883 13.7245 4.0391 11.8508 3.41606 9.77374 3.22773 7.625Zm3.42447 6.3665c-1.20602 -1.906 -1.95252 -4.08967 -2.16926 -6.3665h5.0341c-0.21673 2.27683 -0.96324 4.4605 -2.16927 6.3665 -0.11521 0.0056 -0.23116 0.0085 -0.34776 0.0085 -0.11663 0 -0.23258 -0.0029 -0.34781 -0.0085Zm2.29895 -0.267c2.72395 -0.789 4.76375 -3.1882 5.02135 -6.0995h-3.2003c-0.1883 2.14875 -0.81133 4.2258 -1.82105 6.0995ZM10.7722 6.375h3.2003c-0.2576 -2.91128 -2.2974 -5.31049 -5.02136 -6.099467C9.96087 2.14921 10.5839 4.22625 10.7722 6.375ZM6.65221 0.00848953C6.76743 0.00285182 6.88339 0 7.00001 0c0.1166 0 0.23255 0.0028513 0.34776 0.008488C8.5538 1.91446 9.3003 4.09817 9.51704 6.375h-5.0341c0.21674 -2.27683 0.96324 -4.46054 2.16927 -6.36651047Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebGlobeIcon);
export default __webpack_public_path__ + "static/media/web-globe-icon.5d0e002525c74dce97d4fa74ec853a03.svg";
export { ForwardRef as ReactComponent };